<a
  routerLinkActive="bl-menu__link--active"
  title="Analytics"
  class="bl-menu__link--dark"
  (click)="menu1.toggle($event)"
>  
  <i class="pi pi-chart-line"></i> 
  Analytics
</a>
<p-menu #menu1 [model]="items" [popup]="true" appendTo="body" />
